import { toGlassesBundleCartLineItem } from "./glasses-bundle-line-item.js";
import { toNonPrescriptionBundleCartLineItem } from "./non-prescription-bundle-line-item.js";
import { isPrescriptionGlassesTypeDetails, isNonPrescriptionBundleTypeDetails } from "../../../utils/mappers/view/visual-line-item/utils/cart-line-item-product-type-guards.js";
const toBundleCartLineItem = (lineItem, intl, settings, apiUrl) => {
  if (lineItem.typeDetails && isPrescriptionGlassesTypeDetails(lineItem.typeDetails)) {
    return toGlassesBundleCartLineItem(lineItem, lineItem.typeDetails, intl, settings, apiUrl);
  }
  if (lineItem.typeDetails && isNonPrescriptionBundleTypeDetails(lineItem.typeDetails)) {
    return toNonPrescriptionBundleCartLineItem(lineItem, intl, settings);
  }
};
export {
  toBundleCartLineItem
};
//# sourceMappingURL=bundle-cart-line-item.js.map
